<template>
  <v-container fill-height>

    <v-layout column wrap align-center justify-center>

      <img src="@/assets/logo.png" width="150" class="mr-4">

      <div>&nbsp;</div>

      <div>&nbsp;</div>

      <div>&nbsp;</div>

      <v-card class="elevation-8 login-form">
        <v-card-title class="login-title" primary-title>
          <h1 style="text-align: center; width: 100%">Login</h1>
        </v-card-title>
        <v-form @submit.native.prevent="login" v-model="valid">

        <v-card-text>

            <v-text-field
              @input="error = null"
              v-model="user.email"
              :error-messages="error"
              prepend-icon="email"
              label="Email"
              :rules="emailRules"
              required
            />

            <v-text-field
              @input="error = null"
              type="password"
              prepend-icon="lock"
              v-model="user.password"
              name="password"
              :rules="passwordRules"
              label="password"
              required
            />

        </v-card-text>

        <v-card-actions>

            <v-btn block ripple type="submit" :disabled="!valid" :loading="loading" color="info">login</v-btn>
            
        </v-card-actions>
        </v-form>
      </v-card>
  </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: "login",
    data() {
      return  {
        loading: false,
        valid: true,
        user: {
          email: "",
          password: ""
        },
        error: null,
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
          v => !!v || 'Password is required',
          v => (v.length > 8 || v.length < 512) || 'Password must be 8 to 512 characters' 
        ]
      }
    },
    methods: {
      async login() {

        this.loading = true;

        try {

          let data = await this.$store.dispatch("login", this.user);

          this.loading = false;

          if (data.user.userRole.name !== "admin") return this.error = "Only admin users can access the administration panel";

          this.$store.commit("login", data);

          localStorage.setItem("session", JSON.stringify(data))

          this.$router.replace("/dashboard");

        } catch(error) {

          if (error === 401) this.error = "Email or password is incorrect!";

          this.loading = false;

          console.error(error);

        }

      }
    }
  }
</script>

<style scoped>
  .login-form {
    max-width: 400px;
    width: 100%;
  }

  .login-title {
    background: #009688;
    color: white;
  }
</style>